import { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { cancelUpdate } from "../services/cancelUpdate";

// Drop this in Admin.jsx's per-row actions, right next to your
// existing Update button - only render it when there's actually
// something to cancel:
//
//   {(device.ota_status === "queued" || device.ota_status === "started") && (
//       <CancelUpdateButton serial={device.serial_no} onDone={load} />
//   )}
//
// `onDone` should be whatever function re-fetches your inventory
// list (probably called `load` in your file) so the row reflects
// the cleared status right away.
export default function CancelUpdateButton({ serial, onDone }) {

    const [busy, setBusy] = useState(false);

    async function handleClick() {

        if (!window.confirm(
            `Cancel the pending update for ${serial}? If it already started downloading, this only clears the dashboard - the device will finish on its own.`
        )) return;

        setBusy(true);

        try {

            const res = await cancelUpdate(serial);
            alert(res.data.message);
            onDone?.();

        } catch (err) {

            alert(err.response?.data?.message || "Couldn't cancel that update.");

        } finally {

            setBusy(false);

        }

    }

    return (

        <button
            className="cancelUpdateBtn"
            onClick={handleClick}
            disabled={busy}
            title="Cancel this update"
        >
            <FaTimes />
        </button>

    );

}
